import { Permission } from './permission.model';

export class Role {
    id: number;
    name: string;
    permissions: Permission[];

    clear(): void {
        this.id = undefined;
        this.name = '';
        this.permissions = [];
    }
}
